import { render, staticRenderFns } from "./MedhopAssistant.vue?vue&type=template&id=209ab9da&scoped=true"
import script from "./MedhopAssistant.vue?vue&type=script&lang=js"
export * from "./MedhopAssistant.vue?vue&type=script&lang=js"
import style0 from "./MedhopAssistant.vue?vue&type=style&index=0&id=209ab9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209ab9da",
  null
  
)

export default component.exports